module.exports = __webpack_public_path__ + "images/060e4be7a22713ad562e8a84101f811c.png";